
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { MuiTypography, MuiGrid } from '../../ui/MaterialUIComponents';
import { Dashboard } from '.'
import { SchoolInformationActions, UserProfileActions } from '../../../store'
import lodashUtil from 'lodash'
import { getKeyFromLS, setDataInLS } from '../../../utils/LocalStorageUtil'
import withAppShell from '../../hoc/withAppShell/WithAppShell';
import DashboardComponent from './DashboardComponent';
class DashboardContainer extends Component {
    showContextualHelp = (props, event) => {
        let content = props.contextualHelp["dashboard"];
        if (content !== undefined) {
            props.toggleDrawer("right", true, content)(event)
        }
    }
    componentWillMount() {
        let i18n;
        if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
            i18n = getKeyFromLS("i18n");
        } else {
            i18n = this.props.i18n
        }
        this.setState({
            i18n: i18n
        })
    }
    render() {
        return (

            <DashboardComponent {...this.props} {...this.state}
                showContextualHelp={this.showContextualHelp}
            />

        )

    }
}
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getSchoolInfromation: (ownerId) => dispatch(SchoolInformationActions.getSchoolInformation(ownerId)),
        setActiveSchool: (school) => dispatch(SchoolInformationActions.setActiveSchool(school)),
        getSchoolInformationByAdminId: (ownerId, adminId) => dispatch(SchoolInformationActions.getSchoolInformationByAdminId(ownerId, adminId)),
        editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
        makeOwner: (transferOwnerId) => dispatch(UserProfileActions.makeOwner(transferOwnerId)),
        getUserProfileByCognitoId: (cognitoId) => dispatch(UserProfileActions.getUserProfileByCognitoId(cognitoId)),
        reuestRejectedEmail: (emailId, transferOwnerId, schoolId) => dispatch(UserProfileActions.reuestRejectedEmail(emailId, transferOwnerId, schoolId))

    }
}

const mapStateToProps = (state) => {
    let schools = [];
    if (state.userProfile.userInformation != null) {
        schools = state.userProfile.userInformation.schools
    }
    return {
        user: state.cognito.user,
        getSchoolInformationInProgress: state.schoolInformation.getSchoolInformationInProgress,
        userInformation: state.userProfile.userInformation,
        schoolList: schools,
        activeSchool: state.schoolInformation.activeSchool,
        newList: state.schoolInformation.newList,
        activeProfileType: state.userProfile.activeProfileType,
        getSchoolInformationByIdInProgress: state.schoolInformation.getSchoolInformationByIdInProgress
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(withAppShell(DashboardContainer))
